import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
Wrapper.displayName = 'Wrapper';

export const WrapperBooleans = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
WrapperBooleans.displayName = 'WrapperBooleans';
